export class KurooApiError extends Error {
  readonly code: string;
  readonly requestId?: string;
  readonly details?: unknown;

  constructor(code: string, message: string, requestId?: string, details?: unknown) {
    super(message);
    this.name = "KurooApiError";
    this.code = code;
    this.requestId = requestId;
    this.details = details;
  }
}
